import { render } from "./Conversation.vue?vue&type=template&id=165896a9&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=165896a9&scoped=true&lang=css"
import "./Conversation.vue?vue&type=style&index=1&id=165896a9&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165896a9"]])

export default __exports__